var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMaxSize, IsArray, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
import { CreateAppointmentParticipantDto } from './create-appointment-participant.dto.js';
export class CreateAppointmentDto {
    therapistId;
    scheduledStart;
    plannedDuration;
    treatmentLocation;
    officeLocationId;
    service;
    description;
    roomId;
    deviceIds = [];
    officeProductAssignmentId;
    // No @ArrayMinSize: a zero-participant appointment is a valid Internes Event (ADR-0005).
    participants = [];
    // Paired with billableServiceItemIds: set both or neither (ADR-0009). When
    // present, the appointment is linked to its Treatment Plan and consumes one
    // unit per billable item via the appointment.created event.
    treatmentPlanId;
    billableServiceItemIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentDto.prototype, "therapistId", void 0);
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CreateAppointmentDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateAppointmentDto.prototype, "plannedDuration", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    __metadata("design:type", String)
], CreateAppointmentDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentDto.prototype, "officeLocationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentDto.prototype, "description", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentDto.prototype, "roomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateAppointmentDto.prototype, "deviceIds", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentDto.prototype, "officeProductAssignmentId", void 0);
__decorate([
    IsArray(),
    ArrayMaxSize(5),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentParticipantDto),
    __metadata("design:type", Array)
], CreateAppointmentDto.prototype, "participants", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateAppointmentDto.prototype, "billableServiceItemIds", void 0);
//# sourceMappingURL=create-appointment.dto.js.map